angular.module('IndicatorType').controller('IndicatorSetModalController', ['$scope', '$uibModalInstance', '$filter', 'data', function($scope, $uibModalInstance, $filter, data) {
  'use strict';

  $scope.indicatorSet = data.indicatorSet;
  /**
   * Closes the creation modal window
   */
  $scope.close = function () {
    $uibModalInstance.dismiss($scope.indicatorSet);
  };

  /**
   * Closes the modal window and returns the data for the new indicatorSet
   * @param {object} indicatorSet object consisting of title and category id
   */
  $scope.updateIndicatorSet = function (indicatorSet) {
    indicatorSet.added = true;
    $uibModalInstance.close(indicatorSet);
  };
}]);
